/** @jsxImportSource theme-ui @jsxRuntime classic */
import { AnchorSection, Box, Container, Flex, Text } from '@tishman/components';
import React from 'react';

import {
  ICard,
  PrivateDiningAndVenuesGrid,
} from '../../components/DiningAndVenuesGrid/DiningAndVenuesGrid';

interface PrivateDiningProps {
  cards: Queries.SanityPrivateDiningAndVenueCardType[];
  description?: string;
  id: string;
  title: string;
  showLearnMoreOnMobile?: boolean;
  hasFeatureCard?: boolean;
  desktopGridColumns?: number;
  desktopGridGap?: string;
  variant?: 'default' | 'private-events';
}

const PrivateDiningAndVenues = ({
  cards,
  description,
  id,
  title,
  showLearnMoreOnMobile = false,
  hasFeatureCard = false,
  desktopGridColumns = 3,
  desktopGridGap = '32px 16px',
}: PrivateDiningProps): JSX.Element => {
  return (
    <AnchorSection id={id}>
      <Container paddingY={['28px', 6]}>
        {/* PRIVATE DINING TITLE & SUBTITLE */}
        <Flex
          sx={{
            flexDirection: ['column', 'row'],
            justifyContent: 'space-between',
            mb: '24px',
            px: 2,
          }}
        >
          {/* PRIVATE DINING TITLE */}
          <Box sx={{ maxWidth: '415px', width: '100%' }}>
            <Text
              sx={{
                fontSize: [5, 7],
                fontWeight: 'medium',
                lineHeight: ['34px', '52px'],
                variant: 'heading',
              }}
            >
              {title}
            </Text>
          </Box>
          {/* PRIVATE DINING SUBTITLE */}
          {description && (
            <Box sx={{ maxWidth: '415px', width: '100%' }}>
              <Text
                sx={{
                  fontSize: '16px',
                  pb: [3, 6],
                  pt: 3,
                }}
                variant="mediumP"
              >
                {description}
              </Text>
            </Box>
          )}
        </Flex>
        {/* PRIVATE DINING CARDS */}
        <PrivateDiningAndVenuesGrid
          cards={cards as ICard[]}
          desktopGridColumns={desktopGridColumns}
          desktopGridGap={desktopGridGap}
          hasFeatureCard={hasFeatureCard}
          showLearnMoreOnMobile={showLearnMoreOnMobile}
        />
      </Container>
    </AnchorSection>
  );
};

export default PrivateDiningAndVenues;
